import { render, staticRenderFns } from "./ModalSolicitacaoCancelamentoMedico.vue?vue&type=template&id=31f8612c&scoped=true"
import script from "./ModalSolicitacaoCancelamentoMedico.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCancelamentoMedico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8612c",
  null
  
)

export default component.exports